import React from "react";
import loader from "../../utils/assests/spinner.gif";
import {  Typography } from "@material-ui/core";
import Box from '@mui/material/Box';
function Loader(props: any) {
  const { loading, title } = props;
  return (
    <div className="loader">
      {loading ? (
          <div style={{ textAlign: "center" }}>
            <img src={loader} alt="loader" width="25%" height="25%" />
            <Typography align="center">
              {title}
            </Typography>
          </div>
      ) : (
        ""
      )}
    </div>
  );
}

export default Loader;
